


























import { Component, Prop, Vue } from 'vue-property-decorator';
import TextFieldTooltip from '@/components/elements/statement/FullStatementView/base/TextFieldTooltip.vue';
import TextareaTooltip from '@/components/elements/statement/FullStatementView/base/TextareaTooltip.vue';

interface Data {
  fieldName: string;
  fieldValue: any;
  fieldLabel: string;
  widthFull: boolean;
  fieldHide: boolean;
  isTextarea: boolean;
  isCheckbox?: boolean
}

@Component({
  inheritAttrs: false,
  components: {
    TextFieldTooltip,
    TextareaTooltip
  }
})
export default class WrapperField extends Vue {
  @Prop() private data!: Data;
  // принудительно во всю ширину
  @Prop() private widthForced!: Boolean;

  get isFieldHide(): boolean {
    if (this.data.isCheckbox) {
      // если чекбокс не скоываем
      return false;
    } else if (
      ['object', 'boolean'].includes(typeof this.data.fieldValue) ||
      ['type', 'code'].includes(this.data.fieldName)
    ) {
      return true;
    } else {
      return false;
    }
  }
}
